import React from 'react';

import classNames from 'classnames/bind';
import style from './Steps.scss';
const ctx = classNames.bind(style);

const Steps = props => (
  <div className={props.className}>
    <div className={ctx('steps')}>
      {props.steps.map(({ title }, idx) => (
        <div className={ctx('step')} key={idx}>
          <span
            className={ctx('link', {
              'link--isActive': idx === props.activeIdx,
            })}
            onClick={props.onChooseStep.bind(null, idx)}
          >
            {title}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default Steps;
